import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
  listAll,
  deleteObject,
  deleteFolder,
} from "firebase/storage";
import { getUid } from "../auth";

export function getStorageRef(path) {
  let finalPath = String(path);
  const st = getStorage();

  if (finalPath.includes("{{uid}}")) {
    const { uid } = getUid();
    finalPath = finalPath.replace("{{uid}}", `${uid}`);
  }

  if (finalPath.includes("{{file_uid}}")) {
    const fileUid = crypto.randomUUID();
    finalPath = finalPath.replace("{{file_uid}}", `${fileUid}`);
  }

  const fileRef = ref(st, finalPath);

  return fileRef;
}

export async function uploadFile({ data, path, extension, format }) {
  const storageRef = getStorageRef(`${path}.${extension}`);
  let res = null;

  if (format === "data_url" || format === "base64url" || format === "base64") {
    res = await uploadString(storageRef, data, format);
  }

  return { res, ref: storageRef };
}

export async function uploadProfilePicture({ data, extension }) {
  const { res, ref } = await uploadFile({
    data,
    path: `users/{{uid}}/profile_picture`,
    extension: extension,
    format: "data_url",
  });

  const url = await getDownloadURL(ref);

  return url;
}

export async function uploadAttachedFile({ data, extension }) {
  const { res, ref } = await uploadFile({
    data,
    path: `users/{{uid}}/files/{{file_uid}}`,
    extension: extension,
    format: "data_url",
  });

  const url = await getDownloadURL(ref);

  return url;
}

export async function uploadChatFile({ data, extension, chatId }) {
  const { res, ref } = await uploadFile({
    data,
    path: `chats/${chatId}/files/{{file_uid}}`,
    extension: extension,
    format: "data_url",
  });

  const url = await getDownloadURL(ref);

  return url;
}

export async function deleteChatFolder({ chatId }) {
  const st = getStorage();
  const folderRef = ref(st, `/chats/${chatId}/files`);

  let promiseArr = [];

  const result = await listAll(folderRef);

  result.items.forEach((itemRef) => {
    promiseArr.push(deleteObject(itemRef));
  });

  await Promise.allSettled(promiseArr);

  return null;
}
